import {ReactComponent as Icon1} from '../../../Assets/Icons/Notification.svg';
import {ReactComponent as Icon2} from '../../../Assets/Icons/contact.svg';
import {ReactComponent as Icon3} from '../../../Assets/Icons/share.svg';

export const features = [
    {
        icon:<Icon1 />,
        title:"Notifications",
        desc:"See who’s working on what and get activity notifications."
    },
    {
        icon:<Icon2/>,
        title:"Mentions",
        desc:"Keep everyone up to date, use @mention to notify other users."
    },
    {
        icon:<Icon3/>,
        title:"Share",
        desc:"Share and present, with simple public web link. No registration needed."
    }
]